import script from "./AddPendencyModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddPendencyModal.vue?vue&type=script&setup=true&lang=js"

import "./AddPendencyModal.vue?vue&type=style&index=0&id=b435711a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b435711a"]])

export default __exports__